
		
			<div class="modal-header">
				<h4 class="modal-title">{{title}}</h4>
				<button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<img alt="" class="kt-widget7__img" width="100%" src="{{photoUrl}}">
			</div>
			<div class="modal-footer" style="justify-content: center;">
				<!--<button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Cross click')">Kapat</button>-->
				<span>{{subTitle}}</span>
			</div>
	
	
